import { useCookies } from 'react-cookie'
import { useQuery as apolloUseQuery } from '@apollo/client'
import { isIGiftCardCartItem } from '../helpers/is-gift-card-cart-item'
import { GetCart } from '../../../apps/checkout/src/client/graphql/queries'
import { ICart } from '../../../apps/checkout/src/client/types/cart'
import { IUniversalCart } from '../types'
import { RawCookieName } from '../constants'

const cartIdCookieName = RawCookieName.CART_ID

const useQueryFallback = (_arg1: unknown, _arg2: unknown): undefined =>
  undefined

function useCart(
  useQuery:
    | typeof apolloUseQuery
    | ((_arg1: unknown, _arg2: unknown) => undefined) = useQueryFallback
): ICart | undefined {
  const [cookies] = useCookies([cartIdCookieName])

  const cartId = cookies[cartIdCookieName]
  const result = useQuery<{ cart: ICart }>(GetCart, {
    context: { version: 2 },
    variables: { id: cartId },
    skip: !cartId,
    fetchPolicy: 'cache-and-network',
  })

  return result?.data?.cart
}

export function useUniversalHeaderCart(
  useQuery:
    | typeof apolloUseQuery
    | ((_arg1: unknown, _arg2: unknown) => undefined) = useQueryFallback,
  isDGCContext?: boolean
): IUniversalCart {
  const cart = useCart(useQuery)

  const showDGCCart =
    (isDGCContext && !cart?.marketplaceItems?.length) || cart?.items?.length

  return {
    url: showDGCCart ? `/shop/cart` : `/shop/cart2`,
    count: showDGCCart
      ? cart?.items?.filter(isIGiftCardCartItem)?.length
      : cart?.marketplaceItems?.reduce((sum, item) => sum + item.quantity, 0),
  }
}
